import { Component, OnInit, input, signal } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ConfigurationSaisieDonneesAnalyse, ModeSaisie } from 'src/app/bo/configurationSaisieDonneesAnalyse';
import { DonneeAnalyse } from 'src/app/bo/donneeAnalyse';
import { Projet } from 'src/app/bo/projet';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { TraductionService } from 'src/app/services/traduction.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { TypeParent } from '../donnees-analyse/donnees-analyse.component';
import { ItemSortHelper } from 'src/app/utils/itemSortHelper';
import { KpiService } from 'src/app/services/kpi.service';

@Component({
  selector: 'app-noeud-detail',
  templateUrl: './noeud-detail.component.html',
  styleUrls: ['./noeud-detail.component.scss'],
  standalone: false
})
export class NoeudDetailComponent implements OnInit {
  projet = input<Projet>();
  siteId = input<number>();
  listeTirs = signal<number[]>([]);
  donneesAnalyseNoeud = signal<DonneeAnalyse[]>([]);
  configSaisieSite = signal<ConfigurationSaisieDonneesAnalyse[]>([]);
  tabTradModeSaisie = signal<string[]>([]);
  initAnalyseFaite = signal(false);
  oldListeTirs = signal('');
  TypeParent = TypeParent;
  nomNoeud = signal<string>('');

  constructor(private readonly fonctionsService: FonctionsService, private readonly traductionService: TraductionService,
    private readonly utilService: UtilisateurService, private readonly kpiService: KpiService) { }

  ngOnInit(): void {
    this.nomNoeud.set(this.utilService.currentNode);
    this.utilService.currentNode$.subscribe(nom => this.nomNoeud.set(nom));
    this.utilService.tirsSelectionnes$.subscribe(tirs => {
      if (tirs) {
        this.listeTirs.set(tirs);
        if (this.oldListeTirs() != this.listeTirs().join(',')) {
          this.initAnalyseFaite.set(false);
          this.configSaisieSite.set([]);
          this.donneesAnalyseNoeud.set([]);
          this.chargerDonneesAnalyse();
        }
      }
    });
    this.listeTirs.set(this.utilService.tirsSelectionnes);
    if (this.listeTirs() !== null && this.listeTirs() !== undefined && this.listeTirs().length > 0) {
      this.chargerDonneesAnalyse();
    }
  }

  async chargerDonneesAnalyse() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    const queryParams = this.listeTirs().join('&blastsId=');
    let donneesAnalyseProjet = this.kpiService.getBlaststAnalysisData(queryParams);
    let configSaisieSite = this.kpiService.getSiteConfigAnalysisEntry(this.siteId());

    forkJoin([donneesAnalyseProjet, configSaisieSite]).subscribe(resultats => {
      this.traductionService.translate.get(['GLOBAL.MOYENNE', 'GLOBAL.SOMME', 'GLOBAL.MINIMUM', 'GLOBAL.MAXIMUM']).subscribe(async res => {
        this.tabTradModeSaisie.set(res);
        resultats[0].forEach(donnee => {
          let config = resultats[1].find(o => o.referentielDonneeAnalyseId == donnee.referentielDonneeAnalyseId);
          donnee.autorisePourUtil = false;

          donnee.isEnabled = config.isEnabled;
          donnee.accessPermission = config.accessPermission;

          switch (config.modeSaisieDonneeProjet) {
            case ModeSaisie.Manuelle:
              donnee.modeSaisie = this.tabTradModeSaisie()['GLOBAL.MANUELLE'];
              break;
            case ModeSaisie.Max:
              donnee.modeSaisie = this.tabTradModeSaisie()['GLOBAL.MAXIMUM'];
              break;
            case ModeSaisie.Min:
              donnee.modeSaisie = this.tabTradModeSaisie()['GLOBAL.MINIMUM'];
              break;
            case ModeSaisie.Somme:
              donnee.modeSaisie = this.tabTradModeSaisie()['GLOBAL.SOMME'];
              break;
            case ModeSaisie.Moyenne:
              donnee.modeSaisie = this.tabTradModeSaisie()['GLOBAL.MOYENNE'];
              break;
            default:
              break;
          }
        });

        try {
          resultats[0] = await ItemSortHelper.sortKpi(resultats[0]);
        } catch (error) { }

        this.fonctionsService.loading_screen(false);
        clearTimeout(startLoader);
        this.initAnalyseFaite.set(true);
        this.donneesAnalyseNoeud.set(resultats[0]);
        this.configSaisieSite.set(resultats[1]);
        this.oldListeTirs.set(this.listeTirs().join(','));
      });
    }, () => {
      this.fonctionsService.loading_screen(false);
    }, () => { });
  }


}


